var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeywordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "translate(24.1855) scale(-1 1)",
    fill: "white",
    stroke: "#D41292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.496V4.592L6.72 0H9.808L5.36 4.944C5.744 5.47733 6.45333 6.47467 7.488 7.936C8.52267 9.38667 9.296 10.4693 9.808 11.184H6.896L3.616 6.768L2.496 8.016V11.184H0V0Z",
    transform: "translate(7.18555 6)",
    fill: "#D41292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordIcon);
export default __webpack_public_path__ + "static/media/keyword-icon.1b1dcb5a752224b064a98403d730a5c0.svg";
export { ForwardRef as ReactComponent };